function scrollmore() {

    document.querySelectorAll(".toplist").forEach(function(morelist){
        morelist.onclick = function(list) {
            
            var slide = list.target.closest(".slide-list");
            if (slide) {
                var scrollableList = slide.querySelector('ul');
                if (scrollableList && scrollableList.offsetTop < 0) scrollableList.style.top = (scrollableList.offsetTop + 36) + 'px';
            }
            list.preventDefault();
        }
    });

    document.querySelectorAll(".botlist").forEach(function(morelist){
        morelist.onclick = function(list) {
            
            var slide = list.target.closest(".slide-list");
            if (slide) {
                var scrollableList = slide.querySelector('ul');
                if (scrollableList) scrollableList.style.top = (scrollableList.offsetTop - 36) + 'px';
            }
            list.preventDefault();
        }
    });
}

export default scrollmore;